import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Menu,
  MenuItem,
  Icon,
  IconButton,
  // Badge,
  ListItemText,
  ListItem,
  List,
  Divider,
  Drawer,
  ListItemButton,
  TextField,
  Button,
  Rating,
  FormControl,
  InputLabel,
  Select,
  Alert,
} from '@mui/material';
import {
  ContactPhoneOutlined,
  ContentCopyOutlined,
  ContentPasteOutlined,
  EditNoteOutlined,
  HelpOutlineOutlined,
  ThreePOutlined,
  NoteAddOutlined,
  FolderOpenOutlined,
  BugReportOutlined,
  // BedtimeOutlined,
  // SearchOutlined,
  // NotificationsOutlined,
  // SwitchAccountOutlined,
  // ManageAccountsOutlined,
  ExitToAppOutlined,
  AccountCircleOutlined,
  // LightModeOutlined,
  EmailOutlined,
  ChatOutlined,
  SendOutlined,
  StarOutlined,
} from '@mui/icons-material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { submitFeedback } from '../apis/contactApi';
import { useNavigate } from 'react-router-dom';
// import { useThemeContext } from '../Context/ThemeContext'; // Import useThemeContext

const NavigationBar = ({ onTabChange, mainMenu, handleLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
  const [notificationAnchor, setNotificationAnchor] = useState(null);
  const [profileAnchor, setProfileAnchor] = useState(null);
  const [contactSupportOpen, setContactSupportOpen] = useState(false);
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [, setSupportForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [feedbackForm, setFeedbackForm] = useState({
    name: '',
    email: '',
    category: '',
    rating: 0,
    message: '',
  });
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  // const { darkMode, toggleDarkMode } = useThemeContext(); // Use theme context

  const [notifications] = useState([
    'New message from Admin',
    'Reminder: Meeting at 3 PM',
    'Your password was changed successfully',
  ]);

  const navigate = useNavigate();

  // const handleNotificationOpen = (event) => {
  //   setNotificationAnchor(event.currentTarget);
  // };

  const handleNotificationClose = () => {
    setNotificationAnchor(null);
  };

  const handleProfileOpen = (event) => {
    setProfileAnchor(event.currentTarget);
  };

  const handleProfileClose = () => {
    setProfileAnchor(null);
  };

  const handleMenuOpen = (event, menu) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(menu);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setOpenMenu(null);
  };

  const handleLogoutClick = () => {
    handleLogout();
  };

  const handleContactSupportOpen = () => {
    setContactSupportOpen(true);
    handleMenuClose();
  };

  const handleContactSupportClose = () => {
    setContactSupportOpen(false);
    setSupportForm({
      name: '',
      email: '',
      subject: '',
      message: '',
    });
  };

  // Open integrated live chat (HelpdeskFloatingIcon) without toggling if already open
  const handleOpenLiveChat = () => {
    try {
      const chatIframe = document.querySelector(
        'iframe[src*="flowise.hyperminds.tech/chatbot"]',
      );
      if (!chatIframe) {
        document.getElementById('helpdesk-floating-icon')?.click();
      }
    } finally {
      setContactSupportOpen(false);
    }
  };

  const handleEmailSupport = () => {
    const mailtoLink =
      'mailto:support@company.com?subject=Support%20Request&body=Please%20describe%20your%20issue...';
    window.open(mailtoLink, '_blank');
    setContactSupportOpen(false);
  };

  const handleOpenFAQ = () => {
    setContactSupportOpen(false);
    navigate('/help');
  };

  const handleFeedbackOpen = () => {
    setFeedbackOpen(true);
    handleMenuClose();
  };

  const handleFeedbackClose = () => {
    setFeedbackOpen(false);
    setFeedbackForm({
      name: '',
      email: '',
      category: '',
      rating: 0,
      message: '',
    });
    setFeedbackSubmitted(false);
  };

  const handleFeedbackSubmit = async () => {
    try {
      await submitFeedback({
        name: feedbackForm.name?.trim(),
        email: feedbackForm.email?.trim(),
        category: feedbackForm.category || 'general',
        rating: feedbackForm.rating,
        message: feedbackForm.message?.trim(),
      });
      setFeedbackSubmitted(true);
      setTimeout(() => {
        handleFeedbackClose();
      }, 2000);
    } catch (err) {
      console.error('Failed to submit feedback', err);
    }
  };

  const handleFeedbackChange = (field, value) => {
    setFeedbackForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Styled MenuItem for uniform styling across all menus
  const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    py: 4,
    px: 2,
    fontSize: '0.95rem',
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      bgcolor: 'rgba(0, 0, 0, 0.04)',
    },
  }));

  const StyledIcon = styled(Icon)(({ theme }) => ({
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  }));

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          // background: 'linear-gradient(to right, #0061DD, #4BAAFF)',
          background: '#EAF0FF',
          boxShadow: '0px 0px 4px 0px #0000000D',
          zIndex: 1201,
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between',
            minHeight: '40px !important',
            padding: '0px 6px',
          }}
        >
          <Box sx={{ display: 'flex', gap: 2 }}>
            {['Dashboard', 'Help'].map((menu) => (
              <Typography
                key={menu}
                onClick={(event) =>
                  ['File', 'Edit', 'Help'].includes(menu)
                    ? handleMenuOpen(event, menu)
                    : onTabChange(menu)
                }
                sx={{
                  fontSize: '1rem',
                  fontWeight: 500,
                  cursor: 'pointer',
                  px: 1.5,
                  py: 0.75,
                  borderRadius: '6px',
                  position: 'relative',
                  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  color: '#525252',
                  background:
                    mainMenu === menu
                      ? 'rgba(255, 255, 255, 0.15)'
                      : 'transparent',
                  border:
                    mainMenu === menu
                      ? '1px solid rgba(255, 255, 255, 0.2)'
                      : '1px solid transparent',
                  backdropFilter: mainMenu === menu ? 'blur(10px)' : 'none',
                  boxShadow:
                    mainMenu === menu
                      ? 'inset 0 1px 0 0 rgba(255, 255, 255, 0.1)'
                      : 'none',
                  '&:hover': {
                    background:
                      mainMenu === menu
                        ? 'rgba(255, 255, 255, 0.25)'
                        : 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    backdropFilter: 'blur(10px)',
                    transform: 'translateY(-1px)',
                    boxShadow:
                      mainMenu === menu
                        ? 'inset 0 1px 0 0 rgba(255, 255, 255, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1)'
                        : '0 2px 6px rgba(0, 0, 0, 0.1)',
                  },
                  '&:active': {
                    transform: 'translateY(0px)',
                    boxShadow:
                      mainMenu === menu
                        ? 'inset 0 1px 0 0 rgba(255, 255, 255, 0.1)'
                        : 'none',
                  },
                }}
              >
                {menu}
              </Typography>
            ))}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
            {/* Dark Mode Toggle Icon */}
            {/* <IconButton 
              color="inherit" 
              onClick={toggleDarkMode}
              sx={{
                color: '#ffffff',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.05)',
                  backdropFilter: 'blur(10px)',
                },
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              {darkMode ? (
                <LightModeOutlined fontSize="medium" />
              ) : (
                <BedtimeOutlined fontSize="medium" />
              )}
            </IconButton> */}

            {/* Search Icon */}
            {/* <IconButton
              color="inherit"
              sx={{
                color: '#ffffff',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.05)',
                  backdropFilter: 'blur(10px)',
                },
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              <SearchOutlined fontSize="medium" />
            </IconButton> */}

            {/* <IconButton
              color="inherit"
              onClick={handleNotificationOpen}
              sx={{
                color: '#ffffff',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.05)',
                  backdropFilter: 'blur(10px)',
                },
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              <Badge
                badgeContent={notifications.length}
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    animation: 'pulse 2s infinite',
                    '@keyframes pulse': {
                      '0%': {
                        transform: 'scale(1)',
                        opacity: 1,
                      },
                      '50%': {
                        transform: 'scale(1.1)',
                        opacity: 0.7,
                      },
                      '100%': {
                        transform: 'scale(1)',
                        opacity: 1,
                      },
                    },
                  },
                }}
              >
                <NotificationsOutlined fontSize="medium" />
              </Badge>
            </IconButton> */}
            <Menu
              anchorEl={notificationAnchor}
              open={Boolean(notificationAnchor)}
              onClose={handleNotificationClose}
              PaperProps={{
                sx: {
                  bgcolor: '#EAF0FF',
                  color: '#525252',
                  mt: 1,
                  minWidth: '150px',
                  borderRadius: '12px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(20px)',
                },
              }}
            >
              <List>
                {notifications.map((notification, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      borderRadius: '8px',
                      mx: 1,
                      transition: 'all 0.2s ease',
                      ':hover': {
                        cursor: 'pointer',
                        backgroundColor: 'rgba(0, 97, 221, 0.08)',
                        transform: 'translateX(4px)',
                      },
                    }}
                  >
                    <ListItemText primary={notification} />
                  </ListItem>
                ))}
              </List>
            </Menu>

            {/* User Profile */}
            <IconButton
              color="inherit"
              onClick={handleProfileOpen}
              sx={{
                mr: 2,
                color: '#525252',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.05)',
                  backdropFilter: 'blur(10px)',
                },
                '&:active': {
                  transform: 'scale(0.98)',
                },
              }}
            >
              <AccountCircleOutlined fontSize="medium" />
            </IconButton>
            <Menu
              anchorEl={profileAnchor}
              open={Boolean(profileAnchor)}
              onClose={handleProfileClose}
              PaperProps={{
                sx: {
                  bgcolor: 'background.paper',
                  color: 'text.primary',
                  mt: 1,
                  minWidth: '250px',
                  borderRadius: '12px',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(20px)',
                },
              }}
            >
              {/* <MenuItem
                onClick={handleProfileClose}
                sx={{
                  borderRadius: '8px',
                  mx: 1,
                  my: 0.5,
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 97, 221, 0.08)',
                    transform: 'translateX(4px)',
                  },
                }}
              >
                <SwitchAccountOutlined sx={{ mr: 1, color: 'text.primary' }} />
                Switch Profile
              </MenuItem> */}
              {/* <MenuItem
                onClick={handleProfileClose}
                sx={{
                  borderRadius: '8px',
                  mx: 1,
                  my: 0.5,
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 97, 221, 0.08)',
                    transform: 'translateX(4px)',
                  },
                }}
              >
                <ManageAccountsOutlined sx={{ mr: 1, color: 'text.primary' }} />
                Manage Profile
              </MenuItem> */}
              <MenuItem
                onClick={handleLogoutClick}
                sx={{
                  borderRadius: '8px',
                  mx: 1,
                  my: 0.5,
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(244, 67, 54, 0.08)',
                    transform: 'translateX(4px)',
                    color: '#f44336',
                  },
                }}
              >
                <ExitToAppOutlined sx={{ mr: 1 }} />
                Sign Out
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Dropdown Menus */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(openMenu)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            minWidth: 220,
            bgcolor: 'background.paper',
            padding: '0.5rem 0',
            mt: 1.5,
            border: '1px solid rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(20px)',
          },
        }}
      >
        {openMenu === 'File' && (
          <>
            <StyledMenuItem
              onClick={() => {
                onTabChange('New File');
                handleMenuClose();
              }}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon>
                <NoteAddOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              New File
            </StyledMenuItem>
            <StyledMenuItem
              onClick={() => {
                onTabChange('Open File');
                handleMenuClose();
              }}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon>
                <FolderOpenOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Open File
            </StyledMenuItem>
            <StyledMenuItem
              onClick={() => {
                onTabChange('Debug Console');
                handleMenuClose();
              }}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon>
                <BugReportOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Debug Console
            </StyledMenuItem>
          </>
        )}
        {openMenu === 'Edit' && (
          <>
            <StyledMenuItem
              onClick={() => {
                onTabChange('Rename');
                handleMenuClose();
              }}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon>
                <EditNoteOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Rename
            </StyledMenuItem>

            <StyledMenuItem
              onClick={() => {
                onTabChange('Copy Workflow');
                handleMenuClose();
              }}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon>
                <ContentCopyOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Copy Workflow
            </StyledMenuItem>

            <StyledMenuItem
              onClick={() => {
                onTabChange('Paste Workflow');
                handleMenuClose();
              }}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon>
                <ContentPasteOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Paste Workflow
            </StyledMenuItem>
          </>
        )}
        {openMenu === 'Help' && (
          <>
            <StyledMenuItem
              onClick={() => {
                handleMenuClose();
                window.open('/help', '_blank', 'noopener,noreferrer');
              }}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon>
                <HelpOutlineOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Help Document
            </StyledMenuItem>
            <StyledMenuItem
              onClick={handleContactSupportOpen}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon sx={{ mr: 1 }}>
                <ContactPhoneOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Contact Support
            </StyledMenuItem>
            <StyledMenuItem
              onClick={handleFeedbackOpen}
              sx={{
                borderRadius: '8px',
                mx: 1,
                my: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(0, 97, 221, 0.08)',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <StyledIcon sx={{ mr: 1 }}>
                <ThreePOutlined sx={{ color: '#383838' }} />
              </StyledIcon>
              Feedback
            </StyledMenuItem>
          </>
        )}
      </Menu>

      {/* Contact Support Drawer (subtle slide-in panel) */}
      <Drawer
        anchor="right"
        open={contactSupportOpen}
        onClose={handleContactSupportClose}
        PaperProps={{
          sx: {
            width: 320,
            bgcolor: '#EAF0FF',
            color: '#525252',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            Contact Support
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
            How can we help you?
          </Typography>
        </Box>
        <Divider />
        <List sx={{ p: 1 }}>
          <ListItemButton
            onClick={handleOpenLiveChat}
            sx={{
              borderRadius: '8px',
              mx: 0.5,
              my: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 97, 221, 0.08)',
                transform: 'translateX(4px)',
              },
            }}
          >
            <StyledIcon>
              <ChatOutlined sx={{ color: '#383838' }} />
            </StyledIcon>
            <ListItemText primary="Live Chat" secondary="Chat with us now" />
          </ListItemButton>

          <ListItemButton
            onClick={handleEmailSupport}
            sx={{
              borderRadius: '8px',
              mx: 0.5,
              my: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 97, 221, 0.08)',
                transform: 'translateX(4px)',
              },
            }}
          >
            <StyledIcon>
              <EmailOutlined sx={{ color: '#383838' }} />
            </StyledIcon>
            <ListItemText
              primary="Email Support"
              secondary="support@company.com"
            />
          </ListItemButton>

          <ListItemButton
            onClick={handleOpenFAQ}
            sx={{
              borderRadius: '8px',
              mx: 0.5,
              my: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 97, 221, 0.08)',
                transform: 'translateX(4px)',
              },
            }}
          >
            <StyledIcon>
              <HelpOutlineOutlined sx={{ color: '#383838' }} />
            </StyledIcon>
            <ListItemText primary="FAQs" secondary="Browse help articles" />
          </ListItemButton>
        </List>
      </Drawer>
      {/* Contact Support Drawer (subtle slide-in panel) */}
      <Drawer
        anchor="right"
        open={contactSupportOpen}
        onClose={handleContactSupportClose}
        PaperProps={{
          sx: {
            width: 320,
            bgcolor: '#EAF0FF',
            color: '#525252',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
          },
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            Contact Support
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
            How can we help you?
          </Typography>
        </Box>
        <Divider />
        <List sx={{ p: 1 }}>
          <ListItemButton
            onClick={handleOpenLiveChat}
            sx={{
              borderRadius: '8px',
              mx: 0.5,
              my: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 97, 221, 0.08)',
                transform: 'translateX(4px)',
              },
            }}
          >
            <StyledIcon>
              <ChatOutlined sx={{ color: '#383838' }} />
            </StyledIcon>
            <ListItemText primary="Live Chat" secondary="Chat with us now" />
          </ListItemButton>

          <ListItemButton
            onClick={handleEmailSupport}
            sx={{
              borderRadius: '8px',
              mx: 0.5,
              my: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 97, 221, 0.08)',
                transform: 'translateX(4px)',
              },
            }}
          >
            <StyledIcon>
              <EmailOutlined sx={{ color: '#383838' }} />
            </StyledIcon>
            <ListItemText
              primary="Email Support"
              secondary="support@company.com"
            />
          </ListItemButton>

          <ListItemButton
            onClick={handleOpenFAQ}
            sx={{
              borderRadius: '8px',
              mx: 0.5,
              my: 0.5,
              transition: 'all 0.2s ease',
              '&:hover': {
                backgroundColor: 'rgba(0, 97, 221, 0.08)',
                transform: 'translateX(4px)',
              },
            }}
          >
            <StyledIcon>
              <HelpOutlineOutlined sx={{ color: '#383838' }} />
            </StyledIcon>
            <ListItemText primary="FAQs" secondary="Browse help articles" />
          </ListItemButton>
        </List>
      </Drawer>

      {/* Feedback Form Drawer */}
      <Drawer
        anchor="right"
        open={feedbackOpen}
        onClose={handleFeedbackClose}
        PaperProps={{
          sx: {
            width: 400,
            bgcolor: '#EAF0FF',
            color: '#525252',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            borderLeft: '1px solid rgba(0, 0, 0, 0.06)',
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            Share Your Feedback
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
            Help us improve by sharing your thoughts and suggestions.
          </Typography>

          {feedbackSubmitted ? (
            <Alert severity="success" sx={{ mb: 2 }}>
              Thank you for your feedback! We appreciate your input.
            </Alert>
          ) : (
            <Box
              component="form"
              sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              <TextField
                label="Name"
                variant="outlined"
                size="small"
                value={feedbackForm.name}
                onChange={(e) => handleFeedbackChange('name', e.target.value)}
                fullWidth
              />

              <TextField
                label="Email"
                variant="outlined"
                size="small"
                type="email"
                value={feedbackForm.email}
                onChange={(e) => handleFeedbackChange('email', e.target.value)}
                fullWidth
              />

              <FormControl size="small" fullWidth>
                <InputLabel>Category</InputLabel>
                <Select
                  value={feedbackForm.category}
                  label="Category"
                  onChange={(e) =>
                    handleFeedbackChange('category', e.target.value)
                  }
                  native
                >
                  <option value=""></option>
                  <option value="bug">Bug Report</option>
                  <option value="feature">Feature Request</option>
                  <option value="improvement">Improvement Suggestion</option>
                  <option value="general">General Feedback</option>
                  <option value="other">Other</option>
                </Select>
              </FormControl>

              <Box>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Overall Rating
                </Typography>
                <Rating
                  value={feedbackForm.rating}
                  onChange={(event, newValue) =>
                    handleFeedbackChange('rating', newValue)
                  }
                  size="large"
                  icon={<StarOutlined fontSize="inherit" />}
                  emptyIcon={<StarOutlined fontSize="inherit" />}
                />
              </Box>

              <TextField
                label="Your Feedback"
                variant="outlined"
                multiline
                rows={4}
                value={feedbackForm.message}
                onChange={(e) =>
                  handleFeedbackChange('message', e.target.value)
                }
                placeholder="Please share your thoughts, suggestions, or report any issues..."
                fullWidth
              />

              <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                <Button
                  variant="outlined"
                  onClick={handleFeedbackClose}
                  fullWidth
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleFeedbackSubmit}
                  disabled={
                    !feedbackForm.message.trim() || !feedbackForm.name.trim()
                  }
                  startIcon={<SendOutlined />}
                  fullWidth
                  sx={{
                    background: 'linear-gradient(45deg, #0061DD, #4BAAFF)',
                    '&:hover': {
                      background: 'linear-gradient(45deg, #0052CC, #3A99EE)',
                    },
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Drawer>
    </>
  );
};

NavigationBar.propTypes = {
  mainMenu: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
};

export default NavigationBar;
